import { instBundle } from '@/axios.js';

const axiosAdmin2 = instBundle.axiosAdmin2;

const state = {
	reasonList: null,
	causeList: null,
};

const getters = {
	getList: state => key => {
		return state[`${key}List`]
			? [{ name: '전체', value: null }, ...state[`${key}List`]]
			: null;
	},
	reasonList: (state, getters) => getters['getList']('reason'),
	causeList: (state, getters) => getters['getList']('cause'),
};

const mutations = {
	setList(state, { key, nameKey, valueKey, list }) {
		state[`${key}List`] = list.map(item => {
			return {
				name: item[nameKey],
				value: item[valueKey],
			};
		});
	},
};

const actions = {
	async reasonList({ commit }) {
		const { data } = await axiosAdmin2('/v3/api/review/report/reason/list');
		commit('setList', {
			key: 'reason',
			nameKey: 'valueName',
			valueKey: 'valueCode',
			list: data,
		});
	},
	async causeList({ commit }) {
		const { data } = await axiosAdmin2('/v3/api/review/report/cause/list');
		commit('setList', {
			key: 'cause',
			nameKey: 'cause',
			valueKey: 'id',
			list: data,
		});
	},
	async init({ dispatch }) {
		await Promise.all([dispatch('reasonList'), dispatch('causeList')]);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	mutations,
	actions,
};
